import { styled } from '@mui/material/styles';
import { Box } from 'shared/mui/Box';
import { TableBody } from 'shared/mui/Table';

export const StyledTableBody = styled(TableBody)({
  'tr:last-of-type td': {
    borderBottom: 'none',
  },
  'tr:last-of-type th': {
    borderBottom: 'none',
  },
});

export const StyledBox = styled(Box)({
  border: '1px solid #E0E0E0',
  borderRadius: '4px',
});
